import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { auth } from 'firebase/app';
import { Router } from '@angular/router';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

    constructor(
        public afAuth: AngularFireAuth,
        private router: Router,
    ) { }

    ngOnInit() {
    }

    login() {
        const GProvider = new auth.GoogleAuthProvider();
        GProvider.setCustomParameters({
            // hd: 'wi2.it',
            prompt: 'select_account',
        });
        this.afAuth.auth.signInWithPopup(GProvider).then(response => {
            if (!response.user.email.match(/\@(wi2.it)|(ecoflumen.it)$/)) {
                this.afAuth.auth.signOut();
                throw new Error('No grants');
            } else {
                this.router.navigate(['/schedule']);
            }
        }).catch(error => {
            alert('Devi accedere con un account autorizzato.');
            console.log(error);
            this.afAuth.auth.signOut();
        });
    }

    logout() {
        // foo
        this.afAuth.auth.signOut().then( _ => {
            this.router.navigate(['/login']);
        });
    }

}
